import CarForm from "components/Forms/CarForm/CarForm";
import VoorraadModule from "components/VoorraadModule/VoorraadModule";
import { useSearchParams } from "react-router-dom";
import ProgressBar from "components/ProgressBar/ProgressBar";
import Container from "components/hoc/Container";

export const StapVoertuigGegevens = () => {
    const [searchparams] = useSearchParams();

    return (
        <>
            <div className="container mx-auto px-5 max-w-full mb-10 border-b border-b-slate-200">
                <ProgressBar />
            </div>
            <Container>
            {searchparams.get("type") === 'voorraad' ?
                <VoorraadModule />
                :
                <CarForm />
            }
            </Container>
        </>
    )
}

export default StapVoertuigGegevens;